var _style, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 10,
    viewBox: "0 0 40 10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    circle {\n      animation: c1 1.4s infinite ease-in-out;\n      fill: white;\n      opacity: 0;\n      transform-origin: center center;\n    }\n\n    #c1 {\n      animation-delay: -0.32s;\n    }\n\n    #c2 {\n      animation-delay: -0.16s;\n    }\n\n    @keyframes c1 {\n      0% {\n        opacity: 0;\n        transform: scale(0);\n      }\n\n      20% {\n        opacity: 0;\n      }\n\n      40% {\n        opacity: 1;\n        transform: scale(1);\n      }\n\n      60% {\n        opacity: 1;\n        transform: scale(1);\n      }\n\n      80% {\n        opacity: 0;\n      }\n\n      100% {\n        opacity: 0;\n        transform: scale(0);\n      }\n    }\n  ")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "c1",
    cx: 5,
    cy: 5,
    r: 5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "c2",
    cx: 20,
    cy: 5,
    r: 5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "c3",
    cx: 35,
    cy: 5,
    r: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingDots);
export default __webpack_public_path__ + "static/media/loading_dots.84116c30d20ac082dc8732d31d847fcf.svg";
export { ForwardRef as ReactComponent };